<img *ngIf="options.type === 'IMAGE'" [src]="mapUrl" [ngClass]="options.extraClass ? options.extraClass : ''"
    alt="Location Preview">
<iframe title="locationPreview" *ngIf="options.type === 'IFRAME' && url" [src]="url"
    [ngClass]="options.extraClass ? options.extraClass : ''" [width]="options.width" [height]="options.height"></iframe>

<div *ngIf="options.type === 'LEAFLET'" class="map-container w-full h-full bg-gray-400 relative" [ngClass]="options.extraClass ? options.extraClass : ''">
    <div *ngIf="options.address" class="bg-white absolute w-1/3 top-2.5 left-2.5 p-2.5 pt-0.5 border-1 shadow rounded-sm z-10">
        <b class="text-base block capitalize flex items-center justify-between" [ngClass]="{'my-2': !options.showNavigationIcon}">
            {{options.label ? options.label : options.module.toLowerCase()}} {{'address.text' | translate}}
            <span class="cursor-pointer pt-1 z-50"
            *ngIf="options?.coords && options.showNavigationIcon"
            [matTooltip]="('text.view_on_map' | translate)"
            matTooltipPosition="right">
                <a class="flex items-center justify-center rounded-full h-10 w-10 p-2 hover:bg-gray-200 text-primary-500 cursor-pointer"
                    target="_blank" href="{{utilityService.getMapsCoordinatesUrl(options?.coords[0], options?.coords[1])}}">
                    <em class="ti ti-send text-xl"></em>
                </a>
            </span>
        </b>
        <div class="flex font-medium text-base text-gray-500">
            <span>{{getFormattedAddress(options.address)}}</span>
        </div>
    </div>
    <div id="map"></div>
</div>